import React from 'react';
import PropTypes from 'prop-types';

const SinceWin = ({ profileType, days, runs, type }) => (
    profileType === 'owner' || !(days || runs) ? null : (
        <span className="mp-form__stats">
            <span className="mp-form__stats__label">Since win {type}: </span>
            <strong>
                {runs}&nbsp;
            </strong>
            {profileType === 'jockey' ? 'rides' : 'runs'}&nbsp;
            <strong>
                {days}&nbsp;
            </strong>
            days
        </span>
    )
);

SinceWin.propTypes = {
    profileType: PropTypes.string,
    type: PropTypes.string,
    days: PropTypes.number,
    runs: PropTypes.number,
};

export default SinceWin;



// WEBPACK FOOTER //
// ./src/js/human/form/components/SinceWin.jsx